import { useLazyQuery } from '@apollo/client'
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import {
  buildFeatureSet,
  getCredentials,
  hasRequiredFeatures
} from '../../cache/auth'
import PageHeader from '../../components/PageHeader'
import { FileStatus, ImageProps } from '../../components/UploadBox/ImageBox'
import { UploadBox } from '../../components/UploadBox/index'
import { ACCOMMODATION_COVER_IMAGE_QUERY } from '../../graphql/upload'
import accommodationPagesRoleManagement from '../../staticRoleManagement/accommodationsRoleManagement'
import { Image } from '../../types/image'

interface UploadBoxForAccommodationCoverProps {
  title: string
}

export const UploadBoxForAccommodationCover: React.FC<
  UploadBoxForAccommodationCoverProps
> = ({ title }) => {
  const [images, setImages] = useState<ImageProps[]>([])
  const params = useParams<{
    accID: string
    propertyCode: string
  }>()

  const [getCoverImage, { data, loading }] = useLazyQuery<{
    accommodationCoverImage: Image
  }>(ACCOMMODATION_COVER_IMAGE_QUERY, {
    fetchPolicy: 'network-only'
  })

  useEffect(() => {
    getCoverImage({
      variables: {
        propertyCode: params.propertyCode
      }
    })
  }, [])
  useEffect(() => {
    if (data) {
      let newImages: ImageProps[] = []

      newImages = [
        {
          fileURL: data.accommodationCoverImage.url,
          status: FileStatus.COMPLETED,
          fileName: data.accommodationCoverImage.name,
          fileSize: data.accommodationCoverImage.size,
          mediaID: data.accommodationCoverImage.id
        }
      ]

      setImages(newImages)
    }
  }, [loading, data])

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const hasAccessToUploadCoverImage = hasRequiredFeatures(
    accommodationPagesRoleManagement
      .find(
        (item) => item.route === '/accommodations/:accID/:propertyCode/:page'
      )
      ?.tabs?.find((tabItem) => tabItem.params.page === 'cover')
      ?.requiredFeatures,
    featureSet
  )

  return (
    <>
      <PageHeader title={title} />
      <UploadBox
        hasAccess={hasAccessToUploadCoverImage}
        loading={loading}
        entityCode={params.propertyCode}
        entityid={params.accID}
        entityType={'Accommodation'}
        images={images}
        setImages={setImages}
        imageType={'Cover'}
      />
    </>
  )
}
